/**
 * SA-8 (Sección 2/15) — vocabulario formal de módulos comerciales,
 * espejo de app/commercial/entitlement_guard.py::ModuleCode. Mismos 7
 * códigos ya usados por Plan.modules (SA-6) / MODULE_OPTIONS
 * (super-admin/commercialModules.ts) — un solo vocabulario, nunca
 * duplicado con nombres distintos.
 */
export const ModuleCode = {
  CENTER_OF_INTELLIGENCE: 'CENTER_OF_INTELLIGENCE',
  TERRITORIAL: 'TERRITORIAL',
  SIGNALS: 'SIGNALS',
  EVOLUTION: 'EVOLUTION',
  GOVIA_AI: 'GOVIA_AI',
  EVIDENCE: 'EVIDENCE',
  REPORTS: 'REPORTS',
} as const

export type ModuleCode = (typeof ModuleCode)[keyof typeof ModuleCode]

/** Espejo de GET /api/v1/me/entitlements — nunca incluye contract_value/
 * cost limits/notas comerciales/precio (Sección 15/34). */
export interface MyEntitlements {
  commercially_managed: boolean
  modules: string[]
}
